export var ServiceType;
(function (ServiceType) {
    ServiceType["INDIVIDUAL"] = "INDIVIDUAL";
    ServiceType["GROUP"] = "GROUP";
    ServiceType["COURSE"] = "COURSE";
})(ServiceType || (ServiceType = {}));
export var OfferedAsType;
(function (OfferedAsType) {
    OfferedAsType["ONE_TIME"] = "ONE_TIME";
    OfferedAsType["PRICING_PLAN"] = "PRICING_PLAN";
})(OfferedAsType || (OfferedAsType = {}));
//# sourceMappingURL=catalog-service.dto.js.map